// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__GlSIR","animate":"icon_animate__jkXOV","spin":"icon_spin__F_Xfh"};